import { Time } from './Time';
import { Input } from './Input';
import { Graphics } from './Graphics';
import { Configuration } from './Configuration';
import { ViewManager } from './ViewManager';

class RenderLoop {
  constructor(app, graphics) {
    this._app = app;
    this._graphics = graphics;
    this._rafId = null;
    this._running = false;
    this._lastDpr = 0;
  }

  set_state(app) {
    if (this._app && this._app.on_exit) {
      // no-op for now
    }
    this._app = app;
    if (app.on_enter) app.on_enter();
  }

  start() {
    if (this._running) return;
    this._running = true;

    if (this._app && this._app.on_enter) {
      this._app.on_enter();
    }

    const loop = () => {
      if (!this._running) return;
      this._rafId = requestAnimationFrame(loop);

      // Update subsystems
      Input.update();
      Time.update();

      // Update DPR only when it actually changes
      if (Graphics._renderer && Configuration.dpr && Configuration.dpr !== this._lastDpr) {
        this._lastDpr = Configuration.dpr;
        Graphics._renderer.setPixelRatio(Configuration.dpr);
      }

      // Update active view (LoaderView, HomeView, etc.)
      ViewManager.update();

      // Application update
      if (this._app && this._app.update) {
        this._app.update();
      }

      // Render
      if (Graphics._renderState && Graphics._renderState.render) {
        Graphics._renderState.render();
      }

      // Post-render
      if (this._app && this._app.on_post_render) {
        this._app.on_post_render();
      }
    };

    this._rafId = requestAnimationFrame(loop);
  }

  stop() {
    this._running = false;
    if (this._rafId) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }
  }
}

export { RenderLoop };
